import { UploadModalShortComponent } from './../upload-modal-short/upload-modal-short.component';
import { Component, ElementRef, EventEmitter, Output, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DocumentUploadButtonComponent } from "./../document-upload-button/document-upload-button.component";

@Component({
    selector: "app-document-upload-drag-and-drop",
    templateUrl: "./document-upload-drag-and-drop.component.html",
    styleUrls: ["./document-upload-drag-and-drop.component.scss"],
    standalone: false
})
export class DocumentUploadDragAndDropComponent extends DocumentUploadButtonComponent {
  @ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef;
  @Output() upload = new EventEmitter();

  files: any[] = [];
  
  constructor(dialog: MatDialog) {
    super(dialog);
  }

  onFileDropped(files) {
    this.prepareFilesList(files);
  }

  openModal(files?: File[]): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const data = {
        title: "Upload Documentation",
        fileName: this.fileName,
        allowedFileTypes: this.allowedFileTypes,
        documentationTypes: this.documentationTypes,
        availableTags: this.availableTags,
        preselectedTagIds: this.preselectedTagIds,
        isStateUser: this.isStateUser,
        availableAdministrativeUnits: this.availableAdministrativeUnits,
        documentTypes: this.documentTypes,
        schoolYears: this.schoolYears,
        preselectedSchoolYear: this.preselectedSchoolYear,
        preselectedDocumentType: this.preselectedDocumentType,
        preselectedAdministrativeUnit: this.preselectedAdministrativeUnit,
        preselectedFiles: files,
        preselectedAdministrativeUnitSurveyId: this.preselectedAdministrativeUnitSurveyId,
        preselectedStudentId: this.preselectedStudentId,
        preselectedIndicatorType: this.preselectedIndicatorType,
        isSchoolYearVisible: this.isSchoolYearVisible,
        isAdministrativeUnitVisible: this.isAdministrativeUnitVisible,
        isPublicVisible: this.isPublicVisible,
      };

      const dialogRef = this.dialog.open(UploadModalShortComponent, { data: data, width: "728px", });
      
      dialogRef.componentInstance.uploadFiles.subscribe((result: any) => {
        if (result) {
          const formData = new FormData();
          result.formArray.forEach((element) => {
            formData.append("DocumentTitles", element.title);
            formData.append("FileNames", element.file.name);
            formData.append("FileTypes", element.type);
            formData.append("Files", element.file, element.file.name);
            formData.append("IsPublic", element.isPublic);
          });
          formData.append("Tags", result.selectedTagIds);
          formData.append("SchoolYear", result.selectedSchoolYear);
          formData.append("AdministrativeUnitId", result.selectedAdministrativeUnit);
          formData.append("DocumentType", result.selectedDocumentType);
          formData.append("ReleaseDate", result.selectedReleaseDate);
          formData.append("AdministrativeUnitSurveyId", result.selectedAdministrativeUnitSurveyId);
          formData.append("StudentId", result.selectedStudentId);
          formData.append("IndicatorType", result.selectedIndicatorType);
          this.upload.emit({ dialogRef, formData });

          resolve(this.fileName);
        } else {
          reject(this.fileName);
        }
      });
    });
  }

  fileBrowseHandler(event) {
    this.prepareFilesList(event.target.files);
  }

  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        this.openModal(this.files)
          .finally(async () => {
            this.files = [];
          });
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index+1);
          } else {
            this.files[index].progress += 10;
          }
        }, 100);
      }
    }, 1000);
  }

  async prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.fileDropEl.nativeElement.value = "";
    await this.uploadFilesSimulator(0);
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
}
